// Edit_stats.js
import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import authToken from "./../token/Token";
import { statsApi } from "./../API/api";

const Edit_stats = ({ match }) => {
  const [statTitle, setStatTitle] = useState("");
  const [statCount, setStatCount] = useState("");
  const [iconUrl, setIconUrl] = useState(null);
  const [initialIconUrl, setInitialIconUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchStatData = async () => {
      try {
        const response = await axios.get(`${statsApi}/${match.params.stat_id}`);

        const statData = response.data.data;

        setStatTitle(statData.stat_title);
        setStatCount(statData.stat_count);
        setInitialIconUrl(statData.icon_url);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    fetchStatData();
  }, [match.params.stat_id]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setIconUrl(file);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    history.push("/components/stats");
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("stat_title", statTitle);
    formData.append("stat_count", statCount);
    formData.append("_method", "PUT");

    if (iconUrl) {
      formData.append("icon_url", iconUrl);
    }

    try {
      await axios.post(`${statsApi}/${match.params.stat_id}`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section>
      <div className="container wrap-section-1">
        <div className="row mx-3">
          <div className="col-lg">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <Form>
                <Form.Group className="mb-3" controlId="statTitle">
                  <Form.Label>Edit Title</Form.Label>
                  <Form.Control
                    type="text"
                    value={statTitle}
                    onChange={(e) => setStatTitle(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="statCount">
                  <Form.Label>Edit Count</Form.Label>
                  <Form.Control
                    type="text"
                    value={statCount}
                    onChange={(e) => setStatCount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="iconUrl">
                  <Form.Label>Edit Icon</Form.Label>
                  <Form.Control type="file" onChange={handleImageChange} />
                  <img
                    src={initialIconUrl}
                    alt="Initial Profile"
                    width="100"
                    className="my-3"
                  />
                </Form.Group>

                <Button variant="warning" onClick={handleSubmit}>
                  Simpan
                </Button>

                <Modal show={showModal} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Data Success Update</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Your data has been successfully updated!
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="warning" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Edit_stats;
